module.exports = __webpack_public_path__ + "static/pakmaya-kurumsal-38b9d5c2e7d369a76a8063e0f687f081.png";